export enum PlantColors{
    Green,
    Yellow,
    Red,
    Black,
    Blue,
    Orange,
    Brown,
}